import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { components } from '@atlaskit/select';
import { N40 } from '@atlaskit/theme/colors';
var popupCustomControlStyles = function popupCustomControlStyles() {
  return {
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    borderBottom: "solid 1px ".concat("var(--ds-border, ".concat(N40, ")"))
  };
};
export var CustomControl = function CustomControl(_ref) {
  var children = _ref.children,
    innerProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, innerProps, {
    getStyles: popupCustomControlStyles
  }), children);
};
export default CustomControl;